<template>
  <Popup
    :open="open"
    :width="300"
    :position="{ top: 42, right: -153 }"
    :border-color="'#dcdde1'"
    :border-radius="4"
    :need-modal="true"
    @modal="$emit('help-center-modal-click')"
  >
    <div class="popup">
      <div class="trigger" @mouseenter="handleTriggerMouseOver('enter')" />
      <div class="popup_title">
        <div class="left">帮助中心</div>
      </div>
      <template v-for="(item, key) in help_center_menu">
        <div :key="key" class="cell" @click="handleCellClick(key)">
          <div class="left">
            <i class="iconfont icon-todo" :class="item.icon" /><span>{{ item.name }}</span>
          </div>
          <div class="right" v-if="item.hasDrawer" :class="!item.toggled && 'revert'">
            <i class="iconfont icon-arrow-down" />
          </div>
        </div>
        <!-- 视频教程 -->
        <div
          :key="key + 'tutorial'"
          class="drawer"
          v-if="key === 0"
          :style="{ height: item.toggled ? 0 : item.drawer_height + 'px' }"
        >
          <div class="video_tutorial">
            <a class="video-item" target="_blank" :href="VIDEO_TUTORIAL[0].url" title="如何查看订阅信息">
              <img :src="VIDEO_TUTORIAL[0].img" alt="如何在电脑官网查询订阅信息" />
            </a>
            <a class="video-item" target="_blank" :href="VIDEO_TUTORIAL[1].url" title="如何更好使用千里马公众号">
              <img :src="VIDEO_TUTORIAL[1].img" alt="如何更好使用千里马公众号" />
            </a>
            <a class="video-item" target="_blank" :href="VIDEO_TUTORIAL[2].url" title="如何查看更多联系人">
              <img :src="VIDEO_TUTORIAL[2].img" alt="如何查看更多联系人" />
            </a>
            <a class="video-more" target="_blank" :href="VIDEO_TUTORIAL[3].url" title="查看更多视频教程">
              查看更多视频教程 >
            </a>
          </div>
        </div>

        <!-- 操作手册 -->
        <div
          :key="key + 'manual'"
          class="drawer"
          v-if="key === 1"
          :style="{
            height: item.toggled ? 0 : 46.5 * (operation_manual.length + 1) + 'px',
          }"
        >
          <div class="operation_manual">
            <router-link
              :key="key"
              v-for="(item, key) in operation_manual"
              target="_blank"
              tag="a"
              :to="{ path: item.url, query: { id: item.id } }"
            >
              {{ item.text }}</router-link
            >
          </div>
        </div>

        <!-- 意见反馈 -->
        <div
          :key="key + 'feedback'"
          class="drawer"
          v-if="key === 2"
          :style="{ height: item.toggled ? 0 : item.drawer_height + 'px' }"
        >
          <div class="feedback">
            <div class="title">期待听到您的声音</div>
            <div class="container">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请在此填写您的宝贵意见"
                v-model="feedback_content"
                :class="{ feedback_content_invalid }"
                :resize="'none'"
              />
              <div class="error" v-if="feedback_content_invalid">请输入反馈内容</div>
            </div>
            <div class="title">联系方式</div>
            <div class="container">
              <el-input
                type="tel"
                placeholder="请填写手机号，方便与我们联系"
                v-model="feedback_mobile"
                :class="{ feedback_mobile_invalid }"
              />
              <div class="error" v-if="feedback_mobile_invalid">请输入正确的手机号</div>
            </div>
            <div class="submit" @click="submit">提交</div>
          </div>
        </div>
      </template>
    </div>
  </Popup>
</template>

<script>
import Popup from "@/components/common/Popup";
import { VIDEO_TUTORIAL } from "@/utils/constants/constants";
import { phoneNumValid } from "@/utils/verificationRules";
import { restAccountManualTree, restAccountMytaskFeedback } from "@/services/common/help-center";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";
import { PRODUCT_MANUAL } from "@/utils/constants/constants.menu";

export default {
  name: "PopupHelpCenter",
  props: {
    open: {
      type: Boolean,
      default: true,
    },
    keywordsLocal: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      help_center_menu: [
        {
          name: "视频教程",
          icon: "icon-play",
          hasDrawer: true,
          toggled: true,
          drawer_height: 574,
        },
        {
          name: "操作手册",
          icon: "icon-bookmark",
          hasDrawer: true,
          toggled: true,
          drawer_height: 46.5,
        },
        {
          name: "意见反馈",
          icon: "icon-write",
          hasDrawer: true,
          toggled: true,
          drawer_height: 350,
        },
      ],
      VIDEO_TUTORIAL,
      operation_manual: [],
      feedback_content: "",
      feedback_mobile: "",
      feedback_content_invalid: false,
      feedback_mobile_invalid: false,
    };
  },
  components: { Popup },
  watch: {
    open(val) {
      if (val) {
        this.$track(DEED_MAP.EXPOSURE, OID_MAP.HELP_CENTER_EXPOSURE);
      }
    },
    feedback_content() {
      this.feedback_content_invalid = false;
    },
    feedback_mobile() {
      this.feedback_mobile_invalid = false;
    },
  },
  methods: {
    // 提交意见反馈
    async submit() {
      this.feedback_content_invalid = !this.feedback_content;
      this.feedback_mobile_invalid = !this.feedback_mobile || !phoneNumValid(this.feedback_mobile);
      if (this.feedback_content_invalid || this.feedback_mobile_invalid) {
        return;
      }
      await restAccountMytaskFeedback({
        suggestion: this.feedback_content,
        contact: this.feedback_mobile,
      });
      this.$message.success("提交完成，您的意见对千里马万分宝贵，感谢反馈~");
      this.feedback_content = "";
      this.feedback_mobile = "";
      this.feedback_content_invalid = false;
      this.feedback_mobile_invalid = false;
    },
    // 个人中心cell点击
    handleCellClick(index) {
      for (let i = 0; i < this.help_center_menu.length; i++) {
        if (i !== index) this.help_center_menu[i].toggled = true;
      }
      this.help_center_menu[index].toggled = !this.help_center_menu[index].toggled;
      this.$emit("cell", this.help_center_menu[index], index);
    },
    handleTriggerMouseOver(status) {
      if (status === "enter") {
        this.$emit("help-center-go-back");
      }
    },
    async getOperationManual() {
      const res = await restAccountManualTree();
      const operation_manual = [];
      for (let i = 0; i < res.data.length; i++) {
        operation_manual.push({
          url: PRODUCT_MANUAL,
          text: res.data[i].contentsName,
          id: res.data[i].id,
        });
      }
      this.operation_manual = operation_manual.slice(0, 4);
    },
  },
  mounted() {
    this.getOperationManual();
  },
};
</script>

<style lang="scss">
@import "../../../assets/config";
// 意见反馈
.feedback {
  .el-textarea__inner {
    width: 100%;
    padding: 10px;
    height: 144px;
    font-size: 12px;
    line-height: 12px;
    background-color: #fff;
    border: 1px solid #eeeef0;
    border-radius: 4px;
  }

  .el-input__inner {
    width: 100%;
    height: 36px;
    padding: 10px;
    line-height: 12px;
    font-size: 12px;
    background-color: #fff;
    border: 1px solid #eeeef0;
    border-radius: 4px;
  }

  .feedback_content_invalid {
    .el-textarea__inner {
      border-color: $theme-color;
    }
  }

  .feedback_mobile_invalid {
    .el-input__inner {
      border-color: $theme-color;
    }
  }
}
</style>

<style scoped lang="scss">
@import "../../../assets/config";

.popup {
  width: 100%;
  margin-top: -50px;

  .trigger {
    width: 100%;
    height: 50px;
    cursor: pointer;
  }

  .popup_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px #ececf3 solid;
    padding: 16px 20px;

    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
  }

  .cell {
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #7c7d81;
    padding: 0 13px;
    font-size: 14px;
    cursor: pointer;

    .left {
      i {
        margin-right: 13px;
      }
    }

    .right {
      transition: all 0.2s linear;

      i {
        font-size: 12px;
      }
    }

    .revert {
      transform: rotate(-180deg);
    }

    &:hover {
      color: $theme-color;
    }

    &:last-child {
      border: none;
    }
  }

  .drawer {
    height: 0;
    overflow: hidden;
    transition: all 0.2s linear;
    border-bottom: 1px #ececf3 solid;
  }

  // 视频教程
  .video_tutorial {
    display: flex;
    flex-direction: column;
    align-items: center;

    .video-item {
      display: flex;
      width: fit-content;
      border: 12px solid #f6f6f8;
      background: #fff;
      border-radius: 4px;
      margin-bottom: 12px;

      img {
        width: 254px;
      }
    }

    .video-more {
      font-size: 12px;
      color: $theme-color;
    }
  }

  // 操作手册
  .operation_manual {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    padding-left: 80px;
    line-height: 36px;
    margin-top: 10px;

    a {
      color: #666666;

      &:hover {
        color: $theme-color;
      }
    }
  }

  // 意见反馈
  .feedback {
    width: 278px;
    height: 100%;
    background-color: #f6f6f8;
    margin: 0 auto;
    padding: 10px;

    .title {
      font-size: 14px;
      color: #45464a;
    }

    .container {
      position: relative;
      margin: 10px 0 20px 0;

      .error {
        position: absolute;
        color: $theme-color;
        font-size: 12px;
      }
    }

    .submit {
      display: block;
      margin-top: 25px;
      height: 32px;
      line-height: 32px;
      background: $theme-color;
      border-radius: 4px;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
</style>
